module.exports = typeof window == 'object';



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/engine-is-browser.js
// module id = 548
// module chunks = 0